export const VIDEO_URLS = {
  CONSTELLATION_DESIGNER:
    'https://spacemap-an2-s3.s3.ap-northeast-2.amazonaws.com/www/Constellation+Designer.mp4',
  RFI_SCANNER:
    'https://spacemap-an2-s3.s3.ap-northeast-2.amazonaws.com/www/RFI+Scanner.mp4',
  SPACE_SCANNER:
    'https://spacemap-an2-s3.s3.ap-northeast-2.amazonaws.com/www/Space+Scanner.mp4',
  ASTRO_1:
    'https://spacemap-an2-s3.s3.ap-northeast-2.amazonaws.com/www/AstroOne.mp4',
  ASTRO_ORCA: '/services/astroOrca.png',
  ASTRO_LIBRARY: '/services/AstroLibrary_3.png',
  ABACUS:
    'https://spacemap-an2-s3.s3.ap-northeast-2.amazonaws.com/www/Abacus.mp4',
  LANDING_PAGE: 
  'https://spacemap-an2-s3.s3.ap-northeast-2.amazonaws.com/www/Video-P1-Landing-page_v1.mp4',
  STAI_AE:
  'https://spacemap-an2-s3.s3.ap-northeast-2.amazonaws.com/www/STAI-AE.mp4',
  CA_SIMULATION:
  'https://spacemap-an2-s3.s3.ap-northeast-2.amazonaws.com/www/CA-simulation.mp4',
} as const;
export type VideoKey = keyof typeof VIDEO_URLS;
